<template>
  <div class="contents_wrapper">
    <div class='contents'>
      <p class="large_white_label">オペレーターマイページ</p>

      <PaymentButtonBlock v-if="isVisible && operatorStripe" :operatorStripe="operatorStripe" />
  </div>

  </div>
</template>

<script>
  import {mapGetters} from "vuex";
  import COLLECTION_NAMES from "@/assets/js/constants/collection_names";
  import caller from "@/assets/js/functions/firebase/cloud_functions/caller";
  import collection from "@/assets/js/functions/firebase/firestore/collection";

  import PaymentTop from "@/assets/js/pages/mypage/operator/payment/PaymentTop";
  import PaymentButtonBlock from "@/components/objects/block/mypage/PaymentButtonBlock";

  export default {
    name: "PaymentTop",

    components: {PaymentButtonBlock},

    mixins: [PaymentTop, collection, caller],

    data() {
      return {
        isVisible: false,
        operatorStripe: {}
      }
    },

    computed: {
      ...mapGetters({uid: 'auth/uid', customClaim: 'auth/customClaim'}),
    },

    beforeCreate() {
      Object.assign(this, {COLLECTION_NAMES});
    },

    async created() {
      await this.getDoc(
        COLLECTION_NAMES.OPERATOR_STRIPES,
        this.uid,
        {}).then(async operatorStripe => {
        this.operatorStripe = operatorStripe;
      }).catch(() => {
        // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
      });

      if (!this.operatorStripe && this.customClaim.isOwner) {
        await this.createStripeCustomAccount()
      }

      this.isVisible = true;
    },

    methods: {
      async createStripeCustomAccount() {
        const requestParam = {
          userId: this.uid,
        };

        await this.callFunction(
          'createStripeCustomAccount',
          requestParam
        ).then(() => {
          window.location.reload();
        }).catch(() => {
          // Vueでは例外に何もしない（thenの処理を発生させたくないので、例外は投げるが関数側で処理済み）
        });
      },
    },
  }
</script>

<style lang="scss" scoped>
  .contents_wrapper {
    background-color: $operator_primary;

    > .contents {
      @include contents();
      margin-bottom: 4rem;

      .large_white_label {
        width: 65%;
      }

      > .payment-button_block {
        width: 70%;
      }
    }
  }
</style>